import React from 'react'
import DropdownButton from './UI/DropdownButton'
import ThemeOption from './Theme/ThemeOption'
import ThemeDropdown from './UI/ThemeDropdown'
import { getThemeName } from '../utils/themeManager'
import { useThemeSelector } from '../hooks/useThemeSelector'

const ThemeSelector = () => {
  const { currentTheme, isOpen, isUpdating, themes, handleThemeChange, toggleOpen } = useThemeSelector()

  return (
    <div className="space-y-4">
      {/* Color Theme Selector */}
      <div className="relative">
        <div className="mb-2">
          <label className="block text-sm font-medium mb-1" style={{color: 'var(--theme-text-primary)'}}>
            Color Theme
          </label>
          <p className="text-xs mb-2" style={{color: 'var(--theme-text-muted)'}}>
            Change the color palette - applies to the entire app
          </p>
        </div>

        <div className="relative">
          <DropdownButton
            onClick={toggleOpen}
            isOpen={isOpen}
            isUpdating={isUpdating}
            currentDisplay={getThemeName(currentTheme)}
          />

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-black/50 backdrop-blur-2xl border border-white/30 rounded-xl shadow-2xl z-50 max-h-64 overflow-y-auto">
              {themes.map((theme) => (
                <ThemeOption
                  key={theme.class}
                  theme={theme}
                  currentTheme={currentTheme}
                  onSelect={handleThemeChange}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Background Type Selector */}
      <div className="relative">
        <div className="mb-2">
          <label className="block text-sm font-medium mb-1" style={{color: 'var(--theme-text-primary)'}}>
            Background Style
          </label>
          <p className="text-xs mb-2" style={{color: 'var(--theme-text-muted)'}}>
            Choose your preferred background animation
          </p>
        </div>
        <ThemeDropdown />
      </div>
    </div>
  )
}

export default ThemeSelector